import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
  Chip,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { getCurrentTerms } from "../../../shared/projectTypeUtils";

export default function SidebarComponent({ data, title, loader, setActive, isEdit, setIsEdit, active, setView, viewKey, temp, typeData }) {
  const [list, setList] = useState([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingTrackerType, setPendingTrackerType] = useState(null);
  const navigate = useNavigate();
  const TERMS = getCurrentTerms()

  useEffect(() => {
    if (data?.length) {
      setList(data);
    }
  }, [data]);

  const handleCardClick = (trackerType, id) => {
    if (isEdit) {
      setPendingTrackerType(trackerType);
      setConfirmOpen(true);
    } else {
      setActive(trackerType);
    }

    // if(trackerType !== "checklist") {
    //   const key = `${id}_${viewKey}`;

    //   if (Object.keys(typeData)?.length && typeData?.[key] === 0) {
    //     setView("Combined");
    //   } else {
    //     setView("Individual");
    //   }
    // } else {
    //   setView("Individual");
    // }
  };

  const handleConfirm = () => {
    setActive(pendingTrackerType);
    setIsEdit(false)
    handleCloseDialog();
  };

  const handleCloseDialog = () => {
    setConfirmOpen(false);
    setPendingTrackerType(null);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          py: 2,
          px: 2,
          fontWeight: 600,
          fontSize: 20,
          cursor: "pointer",
        }}
        onClick={() => navigate("/setup")}
      >
        <Typography fontSize={22} fontWeight={600}>{title}</Typography>
      </Box>

      {loader ? (
        <Box
          sx={{
            height: "calc(100vh - 208px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            px: 2,
            overflowY: "auto",
            height: "calc(100vh - 208px)",
            cursor: "pointer"
          }}
        >
          <Card
            sx={{
              mb: 2,
              backgroundColor: "#4d4a4a",
              color: "white",
              cursor: "pointer",
            }}
            onClick={() => handleCardClick("checklist", '')}
          >
            <CardContent
              sx={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: 600,
              }}
            >
              <Typography mt={1}>Manage Checklist</Typography>
              <ArrowForwardIosIcon style={{ marginTop: "6px" }} fontSize="small" />
            </CardContent>
          </Card>

          {list?.map((item, index) => (
            <Card
              key={index}
              sx={{ mb: 2, border: active === item.tracker_type ? "1px solid #f16253" : "1px solid #c4c4c4" }}
              onClick={() => handleCardClick(item.tracker_type, item?.id)}
            >
              <CardContent>
                <Typography
                  variant="subtitle1"
                  noWrap
                  sx={{
                    fontWeight: 600,
                    maxWidth: "250px",
                  }}
                >
                  {item.tracker_type}
                </Typography>
                {title !== "QC Checklist" ? (
                  <Chip
                    label="Add custom Notes"
                    sx={{ mt: 1, fontWeight: 500, backgroundColor: "#e0e0e0" }}
                  />
                ) : (
                  <Chip
                    label={`${TERMS.TRACKER_LABEL} Type Id : ${item?.id}`}
                    sx={{
                      mt: 1,
                      fontWeight: active === item.tracker_type ? 600 : 500,
                      backgroundColor: active === item.tracker_type ? "#fee2e2" : "#e0e0e0",
                      color: active === item.tracker_type ? "#f16253" : ''
                    }}
                  />
                )}
              </CardContent>
            </Card>
          ))}
        </Box>
      )}

      {/* Alert-style Dialog */}
      <Dialog open={confirmOpen} onClose={handleCloseDialog}>
        <DialogTitle>Unsaved Changes</DialogTitle>
        <DialogContentText sx={{ px: 3, pt: 0 }}>
          You are leaving the page without completing the edits, the Checkpoint will revert to last saved version
        </DialogContentText>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleConfirm} color="error" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
